import { Box, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PlayAndStopButton from "../components/PlayAndStopButton";
import { fromSecondsToHHMMSS } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  textBold: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 700,
    color: "#114668",
    alignSelf: "end",
    textAlign: "right",
  },
  textLight: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "start",
    marginRight: "10px",
  },
  textLightSmall: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "20px",
    fontWeight: 300,
    color: "#1d2319",
    alignSelf: "center",
    marginTop: "-12px",
  },
  textLightBig: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "30px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "center",
    marginBottom: "12px",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0px 24px 0px 24px",
  },
  buttonBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 24px 0px 24px",
    flexDirection: "column",
  },
  break: {
    width: "100%",
    height: "1px",
    marginBottom: "24px",
    backgroundColor: "#bcbcbc",
  },
}));

const CommandDetailView = ({
  command,
  event,
  eklokData,
  onPlayAndStopButtonPressed,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [countDown, setCountDown] = useState(
    event ? event.ACTION_DURATION - event.STARTED_FROM : 0,
  );

  const commandsTypeText = {
    ACTIONS: t("mobile_frame.home.routines"),
    MUSICS: t("mobile_frame.home.musics"),
    MELODIES: t("mobile_frame.home.melodies"),
    MUSICS_SYNTH: t("mobile_frame.home.musicsSynth"),
  };

  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (countDown > 0) {
        setCountDown((countDown) => countDown - 1);
      }
    }, 1000);
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (countDown === 0) {
      clearInterval(intervalRef.current);
    }
  }, [countDown]);

  return (
    <>
      <Box className={classes.buttonBox}>
        <Typography className={classes.textLightBig}>
          {t("mobile_frame.home.details")}
        </Typography>
        <Box className={classes.break} />
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.eklok_name")}
        </Typography>
        <Typography className={classes.textBold}>{eklokData.name}</Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.action_type")}
        </Typography>
        <Typography className={classes.textBold}>
          {commandsTypeText[command.ACTION_TYPE]}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.action_name")}
        </Typography>
        <Typography className={classes.textBold}>
          {command.ACTION_NAME}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.duration")}
        </Typography>
        <Typography className={classes.textBold}>
          {fromSecondsToHHMMSS(command.ACTION_DURATION)}
        </Typography>
      </Box>
      <Box className={classes.horizontalBox}>
        <Typography className={classes.textLight}>
          {t("mobile_frame.home.action_description")}
        </Typography>
        <Typography className={classes.textBold}>
          {command.ACTION_DESCRIPTION}
        </Typography>
      </Box>
      <Box className={classes.buttonBox}>
        <Box className={classes.break} />
        {countDown < 1 ? (
          <Typography className={classes.textLightBig}>
            {t("mobile_frame.home.play_now")}
          </Typography>
        ) : (
          <>
            <Typography className={classes.textLightBig}>
              {t("mobile_frame.home.playing")}
            </Typography>
            <Typography
              className={classes.textLightSmall}
            >{`${fromSecondsToHHMMSS(countDown)} ${t("mobile_frame.home.seconds")}`}</Typography>
          </>
        )}
        <PlayAndStopButton
          onClick={onPlayAndStopButtonPressed}
          isPlaying={countDown > 0}
        />
      </Box>
    </>
  );
};

export default CommandDetailView;
